import styled from '@emotion/styled';
import { Button, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function PageNotFound() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Container>
      <Typography variant="h3">Looking for something 🔍</Typography>
      <Typography variant="body1" color={theme.palette.text.secondary}>
        We couldn't find the page that you're looking for!{' '}
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </Container>
  );
}

export default PageNotFound;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 16px;
`;
